var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionsBgShapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 411,
    viewBox: "0 0 379 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2220_12267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 380,
    height: 411
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.00006 0L378.96 0L378.96 410.72L-1.00006 410.72L-1.00006 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2220_12267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-161.66 149.87C-211.14 199.35 -211.14 279.579 -161.66 329.069C-129.36 361.359 -80.9895 373.849 -37.0795 361.279C-11.0495 353.829 5.15046 337.609 25.8505 321.209C88.5805 271.499 174.7 224.099 256.01 257.059C279.9 266.749 255.67 219.529 251.93 212.509C177.77 73.2695 -5.50953 29.9195 -132.94 125C-143.1 132.58 -152.7 140.9 -161.66 149.87Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-153.44 153.809C-200.67 201.039 -200.67 277.609 -153.44 324.839C-122.62 355.669 -76.4498 367.579 -34.5398 355.589C-9.69981 348.479 5.77019 332.999 25.5202 317.349C85.3902 269.899 167.59 224.659 245.2 256.119C268.01 265.359 244.88 220.299 241.31 213.589C170.53 80.6995 -4.3998 39.3195 -126.02 130.069C-135.72 137.309 -144.88 145.249 -153.44 153.799V153.809Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-145.23 157.749C-190.21 202.729 -190.21 275.649 -145.23 320.619C-115.87 349.969 -71.9098 361.319 -31.9998 349.899C-8.33985 343.129 6.38016 328.389 25.1902 313.479C82.2002 268.299 160.48 225.219 234.39 255.169C256.11 263.969 234.08 221.059 230.68 214.669C163.28 88.1194 -3.30984 48.7194 -119.12 135.139C-128.35 142.029 -137.08 149.589 -145.23 157.739V157.749Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.01 161.69C-179.73 204.41 -179.73 273.68 -137.01 316.4C-109.13 344.28 -67.3698 355.06 -29.4598 344.21C-6.98981 337.78 7.00021 323.78 24.8702 309.62C79.0202 266.7 153.38 225.78 223.58 254.24C244.21 262.6 223.29 221.84 220.06 215.77C156.03 95.5599 -2.1998 58.1299 -112.21 140.22C-120.98 146.76 -129.27 153.95 -137.01 161.69Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.789 165.63C-169.259 206.1 -169.259 271.71 -128.789 312.18C-102.379 338.58 -62.8191 348.8 -26.9091 338.52C-5.6191 332.43 7.6309 319.17 24.5509 305.75C75.8509 265.1 146.281 226.33 212.781 253.29C232.321 261.21 212.501 222.6 209.441 216.85C148.791 102.98 -1.0891 67.5298 -105.299 145.29C-113.609 151.49 -121.459 158.3 -128.789 165.63Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.58 169.57C-158.79 207.78 -158.79 269.74 -120.58 307.95C-95.6398 332.89 -58.2798 342.53 -24.3798 332.83C-4.27981 327.08 8.2302 314.55 24.2202 301.89C72.6602 263.5 139.17 226.9 201.96 252.35C220.41 259.83 201.7 223.37 198.81 217.94C141.54 110.42 0.000198364 76.9398 -98.3998 150.36C-106.25 156.21 -113.66 162.64 -120.58 169.56V169.57Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.359 173.509C-148.319 209.469 -148.319 267.769 -112.359 303.729C-88.8891 327.199 -53.7391 336.269 -21.8291 327.139C-2.9191 321.729 8.86089 309.939 23.9009 298.019C69.4809 261.889 132.071 227.449 191.161 251.399C208.521 258.439 190.911 224.129 188.191 219.019C134.301 117.839 1.1109 86.3292 -91.4891 155.429C-98.8691 160.939 -105.849 166.989 -112.359 173.499V173.509Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.139 177.45C-137.849 211.16 -137.849 265.8 -104.139 299.51C-82.1394 321.51 -49.1894 330.01 -19.2894 321.45C-1.55938 316.38 9.48062 305.33 23.5706 294.16C66.2906 260.3 124.961 228.01 180.341 250.46C196.621 257.06 180.111 224.9 177.561 220.11C127.051 125.27 2.21062 95.7396 -84.5894 160.51C-91.5094 165.67 -98.0494 171.34 -104.159 177.45H-104.139Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.9291 181.39C-127.379 212.84 -127.379 263.83 -95.9291 295.29C-75.3991 315.82 -44.6591 323.75 -16.7491 315.77C-0.209099 311.03 10.0909 300.73 23.2509 290.3C63.1209 258.7 117.861 228.58 169.541 249.53C184.731 255.69 169.331 225.68 166.951 221.21C119.811 132.71 3.3209 105.16 -77.6591 165.59C-84.1191 170.41 -90.2191 175.7 -95.9191 181.4L-95.9291 181.39Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87.7094 185.33C-116.909 214.53 -116.909 261.87 -87.7094 291.06C-68.6494 310.12 -40.1094 317.48 -14.1994 310.07C1.16063 305.67 10.7206 296.11 22.9306 286.43C59.9406 257.1 110.761 229.13 158.741 248.58C172.841 254.29 158.541 226.44 156.331 222.29C112.571 140.13 4.42063 114.55 -70.7594 170.65C-76.7494 175.12 -82.4194 180.03 -87.7094 185.32V185.33Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsBgShapeRed);
export default __webpack_public_path__ + "static/media/solutions_bg_shape_red.c9186860e84567a7c87ee7c8bfd7e1c7.svg";
export { ForwardRef as ReactComponent };